import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
// 导入i18n配置
import i18n from './lang/index';

const app = createApp(App)
app.use(ElementPlus);
app.use(router);
app.use(i18n);
app.mount('#app');
